import { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react';

import { SetState } from '@/types/helpers';

interface MarketWidgetContextType {
  isFullScreen: boolean;
  setIsFullScreen: SetState<boolean>;
  setFullScreenAvailable: SetState<boolean>;
  fullScreenAvailable: boolean;
}

const MarketWidgetContext = createContext<MarketWidgetContextType | undefined>(undefined);

interface MarketAppControlsProviderProps {
  children: ReactNode;
}

export const MarketWidgetProvider = ({ children }: MarketAppControlsProviderProps) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [fullScreenAvailable, setFullScreenAvailable] = useState(false);

  useEffect(() => {
    if (!fullScreenAvailable) {
      setIsFullScreen(false);
    }
  }, [fullScreenAvailable]);

  const value = useMemo(
    () => ({
      isFullScreen,
      setIsFullScreen,
      setFullScreenAvailable,
      fullScreenAvailable
    }),
    [fullScreenAvailable, isFullScreen]
  );

  return <MarketWidgetContext.Provider value={value}>{children}</MarketWidgetContext.Provider>;
};

export const useMarketWidget = (): MarketWidgetContextType => {
  const context = useContext(MarketWidgetContext);
  if (context === undefined) {
    throw new Error('useMarketWidget must be used within a MarketWidgetProvider');
  }
  return context;
};
